import { Image } from 'antd';
import React, { useRef, useState, useEffect } from 'react'; // Importar hooks

const Post = (props: { postGroup: any }) => {
    
    const imageContainerRef = useRef<HTMLDivElement>(null);    
    const [imageHeight, setImageHeight] = useState('200px');
    
    useEffect(() => {
        if (imageContainerRef.current) {
            const height = imageContainerRef.current.offsetHeight;
            setImageHeight(`${height}px`);
        }
    }, [props.postGroup?.mediaItemsURL]); 

    return (
        <div style={{ display: 'flex', margin: '0px', width: '100%', alignItems: 'stretch', justifyContent:'center' }}>
                        
            <div 
                ref={imageContainerRef}
                style={{ fontSize: '16px' }}>
                {
                    props.postGroup?.mediaItemsURL ? 
					props.postGroup?.mediaItemsURL.map((googleUrl: string) => {
                        return (
                            <Image 
                                width='300px'
                                src={googleUrl} 
                                preview={true} 
                                style={{
                                    height: 'auto', 
                                    objectFit: 'cover', 
									margin:'0px',
									padding: '0px',
                                    borderRadius: '20px',
                                    display: 'block'
                                }}
                            />
                        )
                    })
					:
					<h2 style={{width:'300px', height:'200px', border:'.5px solid silver', margin:'0px', borderRadius: '20px', color:'silver', background:'GhostWhite', display:'flex', alignItems: 'center', justifyContent: 'center'}}>Sin foto</h2>
                }
            </div>
            
                <div style={{
                    padding: '15px',
                    margin: '0px',
                    width: '100%',
                    borderRadius: '0px 20px 20px 0px',
                    textAlign: 'justify',
                    background: 'transparent',				                
                    color: 'darkslategrey',
                    maxHeight: imageHeight, 
                    overflowY: 'auto'}}>
                        {props.postGroup.summary}
                </div>
            </div>                   
    );
}

export default Post;